import { RegisterMedium } from '@enmon/commons';
import { Commodity } from '@enmon/commons/lib/shared';

export const REGISTER_MEDIUM_BY_COMMODITY_MAP = {
  [Commodity.Electricity]: RegisterMedium.Electricity,
  [Commodity.NaturalGas]: RegisterMedium.Gas,
  [Commodity.Water]: RegisterMedium.ColdWater,
  [Commodity.Thermal]: RegisterMedium.Heating,
  [Commodity.Other]: RegisterMedium.Other,
} satisfies Record<Commodity, RegisterMedium>;
